<div class="card-stats-wrapper">
  <div class="card-content">
    <h3 [style.color]="card?.color">
      {{ card?.value }}
      @if(valueDescription) {
      <span>{{ valueDescription }} ر.س</span>
      }
    </h3>
    <p>{{ card?.label }}</p>
  </div>
</div>
